<template>
  <div class="">
    <AppScreenTitle title="Accept Waiver" />
    <div class="mb-4 text-xl">I agree to the terms in the event waiver.</div>
    <div class="mb-4 truncate max-w-full">
      <a class="text-action hover:text-action/90 underline" 
         :href="waiverUrl" 
         target="_system">
        Click here to view waiver
      </a>
    </div>
    <div class="text-center">
      <AppButton
        :disabled="isBusy"
        title="Accept"
        @click="handleAcceptWaiver"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
import * as Sentry from "@sentry/vue";
import { storeToRefs } from "pinia";
import { ref } from "vue";
import { useEventParticipantStore } from "@/store/EventParticipant";
import useManageFile from "@/modules/useManageFile";
import AppButton from "@/components/AppButton.vue";
import { useNotificationInjection } from "@/composables/useNotification";
import AppScreenTitle from "./AppScreenTitle.vue";

const waiverUrl = ref("");
const isBusy = ref(false);
const notify = useNotificationInjection();
const { acceptWaiver } = useEventParticipantStore();
const { currentPokerRunEvent } = storeToRefs(useEventParticipantStore());
const { getWaiverPath, openFile } = useManageFile();

const handleAcceptWaiver = async () => {
  isBusy.value = true;
  try {
    await acceptWaiver();
  } catch (ex) {
    Sentry.captureException(ex);
    notify.error("Failed to accept waiver", ex.message);
  } finally {
    isBusy.value = false;
  }
};
const initialize = async () => {
  waiverUrl.value = await openFile(
    currentPokerRunEvent.value.waiver
      ? getWaiverPath(currentPokerRunEvent.value.id, currentPokerRunEvent.value.waiver)
      : ""
  );
};

initialize();
</script>
